import { Tooltip } from "@mui/material";

const CustomTooltip = ({ children, title, position, fontBold }) => {
  return (
    <Tooltip
      arrow
      title={title}
      placement={position}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "#fff",
            color: "#000",
            fontSize: "14px",
            fontFamily: "Inter",
            padding: "8px",
            fontWeight: fontBold,
          },
        },
        arrow: {
          sx: {
            color: "#fff",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
